<script lang="ts">
import { defineComponent } from "vue";

import BundleCard from "@/components/contentBits/bundleCard.vue";
import CertCard from "@/components/contentBits/certCard.vue";
import challengeResult from "@/components/contentBits/challengeCard.vue";
import EventResult from "@/components/contentBits/eventsCard.vue";
import examVoucherCard from "@/components/contentBits/examVoucherCard.vue"; // Import the new component
import GradedLabCard from "@/components/contentBits/gradedLabCard.vue";
import instructorLedResult from "@/components/contentBits/instructorLedCard.vue";
import LabsCard from "@/components/contentBits/labsCard.vue";
import LearningPathResult from "@/components/contentBits/learningPathCard.vue";
import PodCastCard from "@/components/contentBits/podCastCard.vue";
import practiceExamResult from "@/components/contentBits/practiceExamCard.vue";
import scormCard from "@/components/contentBits/scormCard.vue";
import TutorialsResult from "@/components/contentBits/tutorialsCard.vue";
import VideosCard from "@/components/contentBits/videosCard.vue";
import typeMap from "@/consts/cardTypeMap";
import { isScormContent } from "@/utils/isScormContent";

export default defineComponent({
  components: {
    BundleCard,
    CertCard,
    challengeResult,
    EventResult,
    GradedLabCard,
    instructorLedResult,
    LearningPathResult,
    PodCastCard,
    practiceExamResult,
    scormCard,
    TutorialsResult,
    VideosCard,
    examVoucherCard,
    LabsCard,
  },
  props: {
    result: {
      type: Object,
      default: null,
    },
    status: {
      type: Object,
      default: null,
    },
    freeContent: {
      type: Boolean,
      default: false,
    },
    cardView: {
      type: String,
      default: "Grid",
    },
    isRemovable: {
      type: Boolean,
      default: false,
    },
    topicView: {
      type: Boolean,
      default: false,
    },
    isAdminContent: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    forCarousel: {
      type: Boolean,
      default: false,
    },
    showDescription: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentType(): string | null {
      // it could be catalog_data.type, path_data.type, track_data.type, or just type
      let resultType =
        this.result?.catalog_data?.type ??
        this.result?.path_data?.type ??
        this.result?.track_data?.type ??
        this.result?.exam_voucher_data?.type ??
        this.result?.bundle_data?.type ??
        this.result?.type;

      if (resultType === "lab" && this.result?.lab_type === "graded-labs") {
        resultType = "graded-labs";
      }
      if (resultType === "lab" && this.result?.lab_type === "standalone-labs") {
        // Use the generic LabsCard for standalone-labs
        resultType = "lab";
      }

      // SCORM delivery takes precedence over type: a content item (e.g. type: "video")
      // with delivery_method: "scorm" must render as scorm-card, not its type-based card.
      const deliverySource = this.result?.catalog_data ?? this.result;
      if (isScormContent(deliverySource)) {
        return "scorm-card";
      }

      const mappedType = typeMap[resultType as keyof typeof typeMap] ?? null;
      return mappedType;
    },
  },
});
</script>

<template>
  <component
    :is="componentType"
    :result="result"
    :status="status"
    :for-carousel="forCarousel"
    :cardView="cardView"
    :free-content="freeContent"
    :is-removable="isRemovable"
    :topic-view="topicView"
    :is-admin-content="isAdminContent"
    :index="index"
    :show-description="showDescription"
  />
</template>
